import React, { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";
import useSEO from "@/hooks/useSEO";
import {
  ProblemsSection,
  OldVsNewSection,
  SeeConceptSection,
  BenefitsSection,
  BeforeAfterSection,
  DIYWarningSection,
  ProcessSection,
  AfterYouSayYesSection,
  PricingSection,
  CarePlanSection,
  IndustriesSection,
  TrustSection,
  FinalCTASection,
} from "@/components/site/Sections";
import FAQSection from "@/components/site/FAQSection";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useSEO({
    title: "Instant Site Revival — Modern Websites Built Fast for Local Businesses",
    description:
      "Your website might be costing you customers every day. Get a professional website for $750 (normally $1,499) plus $99/month Care & Hosting Plan. Same-day launch available after approval.",
    image: "https://instantsiterevival.com/og-default.png",
    path: "/",
  });

  useEffect(() => {
    const els = document.querySelectorAll(".fade-up");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white text-slate-900 selection:bg-yellow-300">
      <Navbar />
      <main>
        <Hero />
        {/* Beat 1 — Outdated website problem */}
        <ProblemsSection />
        <OldVsNewSection />
        <SeeConceptSection />
        {/* Beat 2 — Website revival transformation */}
        <BeforeAfterSection />
        {/* Beat 3 — Mobile-friendly modern design */}
        <BenefitsSection />
        {/* Beat 4 — Trust and conversion improvement */}
        <TrustSection />
        <DIYWarningSection />
        {/* Beat 5 — Simple process */}
        <ProcessSection />
        <AfterYouSayYesSection />
        {/* Beat 6 — Local businesses served */}
        <IndustriesSection />
        <PricingSection />
        {/* Beat 7 — Website care / performance */}
        <CarePlanSection />
        <FAQSection />
        <ContactSection />
        {/* Beat 8 — Free website audit CTA */}
        <FinalCTASection />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
